import { createEffect } from 'solid-js';
import gsap from 'gsap';

import { cx } from '../utils';

interface Props {
  class?: string;
  duration?: number;
  onEnd?: () => void;
  pause?: boolean;
}

export function CountdownProgressBar1(props: Props) {
  return (
    <div class={cx('w-full bg-[#5d717a] overflow-hidden', props.class)}>
      <svg viewBox="0 0 100 4" class="w-full h-1" preserveAspectRatio="none">
        <rect
          ref={(el) => {
            const animation = gsap.fromTo(
              el,
              {
                scaleX: 1,
                transformOrigin: 'left center',
              },
              {
                scaleX: 0,
                duration: props.duration || 3,
                ease: 'none',
                onComplete: () => {
                  props.onEnd?.();
                },
              }
            );

            onCleanup(() => {
              animation.kill();
            });
            createEffect(() => {
              if (props.pause) {
                animation.pause();
              } else {
                animation.play();
              }
            });
          }}
          x="0"
          y="0"
          width="100"
          height="4"
          fill="#95b1bf"
        />
      </svg>
    </div>
  );
}
